import { Loader2 } from "lucide-react";

function Loader() {
  return (
    <Loader2 className="size-xl text-grayscale-light absolute top-1/2 left-1/2 animate-spin" />
  );
}

export default Loader;
